// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"collage"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M3 3L3 21H9L11 12L13 3L3 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M21 3L13 3L9 21L21 21L21 3Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M13 3L3 3L3 21H9M13 3L21 3L21 16M13 3L11 12M9 21L21 21V16M9 21L11 12M21 16L11 12","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-collage')
export default class CollageIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'collage',
    }
  }
}
